import { zetApi } from '@zet/network'

import {
  ChatHistoryRequestData,
  IChatData,
  IChatReply,
  ICreateChat,
  IOptionData,
  IRating,
  ITicket,
  ITicketCount,
  ITicketListRequestData,
  ITickets,
  LeadOptions,
  LeadsRequestData,
  LeadsResponseData,
} from '../types'

async function createTicket(leadId?: number) {
  const { data } = await zetApi.post<ITickets>('tickets', {
    ...(leadId && { lead_id: leadId }),
  })
  return data?.data
}

async function createChat({
  ticketID,
  message = '',
  code,
  attachments,
}: ICreateChat) {
  const requestData = new FormData()
  ticketID && requestData.append('message', message)
  !!code && requestData.append('code', code.toString())
  !!attachments &&
    attachments?.forEach((value) =>
      requestData.append('attachments', value as Blob)
    )

  const { data } = await zetApi<IChatReply>({
    method: 'post',
    url: `tickets/${ticketID}`,
    data: requestData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data?.data
}

async function getTicketCount() {
  const { data } = await zetApi.get<ITicketCount>('tickets/count')
  return data?.data
}

async function getTicketList({
  offset,
  limit,
  status,
  leadId,
  customerName,
}: ITicketListRequestData) {
  const { data } = await zetApi.get<ITicket>('tickets', {
    params: {
      offset,
      limit,
      status,
      ...(leadId ? { leadId } : {}),
      ...(customerName ? { customerName } : {}),
    },
  })

  return {
    tickets: data?.data?.tickets,
    count: data?.data?.total,
    nextOffset: Number(offset) + 10,
  }
}

async function getChatHistory({
  ticketID,
  offset,
  limit,
}: ChatHistoryRequestData) {
  const { data } = await zetApi.get<IChatData>(`tickets/${ticketID}/chats`, {
    params: {
      offset,
      limit,
    },
  })
  return { ...data.data, nextOffset: Number(offset) + 15 }
}

async function getLeadOptions({ ticketId }: LeadOptions) {
  const { data } = await zetApi.get<IOptionData>('options/lead/status/order', {
    params: {
      ticketId,
    },
  })
  return data.data
}

async function getLeads({
  offset,
  limit,
  status,
  leadId,
  customerName,
}: LeadsRequestData) {
  const { data } = await zetApi.get<LeadsResponseData>('options/leads', {
    params: {
      offset,
      limit,
      status,
      ...(leadId ? { leadId } : {}),
      ...(customerName ? { customerName } : {}),
    },
  })
  return {
    data: data?.data?.leads,
    total: data?.data?.total,
    nextOffset: Number(offset) + 10,
  }
}

async function sendRatings({ rating, comment, tags, ticketID }: IRating) {
  const { data } = await zetApi.post(`tickets/${ticketID}/rating`, {
    rating,
    comment,
    tags,
  })
  return data?.data
}

async function reopenTicket(ticketID: string | number) {
  const { data } = await zetApi.patch(`tickets/${ticketID}/reopen`)
  return data?.data
}

async function getFeedbackFormLink() {
  const { data } = await zetApi.get('/rating/form')
  return data?.data
}

export {
  createChat,
  createTicket,
  getChatHistory,
  getFeedbackFormLink,
  getLeadOptions,
  getLeads,
  getTicketCount,
  getTicketList,
  reopenTicket,
  sendRatings,
}
